import { createTheme } from '@mui/material/styles'
import themeData from './theme.json'

export default createTheme({ ...themeData })
